import { configureStore, ThunkAction, Action, Reducer } from '@reduxjs/toolkit';
import { persistCombineReducers, persistStore, Persistor } from 'redux-persist';
import rootReducer from './rootReducer';
import { authorizationHeaderSetterMiddleware } from 'api/interceptors';
import { logger } from 'redux-logger';
import storage from 'redux-persist/lib/storage';

/* This means that the auth reducer is the only reducer that will be persisted */
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'washhub'],
};

const persistedReducers: Reducer = persistCombineReducers(
  persistConfig,
  rootReducer,
);

export const persistor: any = (callback?: () => void): Persistor =>
  persistStore(store, undefined, callback);

const store = configureStore({
  reducer: persistedReducers,
  middleware: (getDefaultMiddleWares) => [
    ...getDefaultMiddleWares({
      /* Added this to make redux persist work with redux-toolkit
      Source: https://stackoverflow.com/questions/61704805/getting-an-error-a-non-serializable-value-was-detected-in-the-state-when-using
      This still has the default middleware that redux-toolkit adds, we just removed the serializable check for redux-persist's sake
      */
      serializableCheck: false,
    }),
    authorizationHeaderSetterMiddleware,
    logger,
  ],
  devTools: process.env.NODE_ENV !== 'production',
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

export default store;
